import { Locales } from '@griply/types';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSignupUserMutation } from 'shared/hooks/queries/use-signup-user-mutation';
import { getAppOpenPath } from 'shared/hooks/use-navigate-app-open-screen';

export const useSignup = () => {
  const navigate = useNavigate();
  const { mutateAsync, reset, isPending, error } = useSignupUserMutation();

  const signup = useCallback(
    async ({
      name,
      email,
      password,
      locale,
    }: {
      name?: string;
      email: string;
      password: string;
      locale?: Locales;
    }) => {
      const { isSignup } = await mutateAsync({ name, email, password, locale });
      navigate(getAppOpenPath({ onboardingPremium: isSignup }));
    },
    [mutateAsync, navigate],
  );

  return { signup, error, retry: reset, isLoading: isPending };
};
